module.exports = __webpack_public_path__ + "img/438.66f908c2.jpg";